import { createFileRoute } from '@tanstack/react-router';
import { DataPage } from '@/features/settings/DataPage';

export const Route = createFileRoute('/app/settings/data')({
  component: DataPage,
  staticData: { title: 'Data · Settings' },
});
